import { VatSettingsModel } from "../../vat-setting/models/vat-settings.model";

export class ContractTypeGroupModel {
  public contractTypeGroupHashId: string;
  public contractTypGroupName: string;
  public sharedVehicleGroupHashId: string;
  public processingFee: number;
  public plateformUsageCost: number;
  public vatPercentage: number;
  public isActive: boolean;
  public currencySymbol: string;
  public processingFeeDisplay: string;
  public plateformUsageCostDisplay: string;
  public isPenaltyEnabled: boolean = false;
  public penaltyAmount: string;
  public penaltyTimeInterval: string;
  public isGroupTripEnabled: boolean = false;
  public isEditable: boolean;
  public isDeletable: boolean;
  public isTotalContractType: boolean;
  public bearer: number = 1;
  public penaltyVat: string;
  public isCurrencySymbolBefore: boolean = true;
  public vatSettingDefaultCost: boolean = true;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/contracttypegroup/models/contracttypegroup.model.ts